import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useGetCmsInfo } from './hooks/useGetCmsInfo';
import useMenuRedirect from '../Menu/hooks/useMenuRedirect';
import useLazyLoadCarousels from './hooks/useLazyLoadCarousels';
//-----------------------------------------------------------------------------------
import ContentsCarouselContainer from './components/ContentsCarouselContainer';
import { SubMenu } from './../Menu/SubMenu';
import { EpisodeContainer } from '../EpisodeContainer';
import DeleteConfirmationModal from '../DeleteConfirmationModal';
import GridContentsView from 'containers/GridContentsView';
import CarouselLoader from './components/ContentsCarouselContainer/components/CarouselLoader';
import ScrollToTop from 'components/scrollTop/scrollToTop';
import { ContainerRecordingBar } from './components/ContentsCarouselContainer/components/ContainerRecordingBar';
import AddonHeader from '../Menu/components/AddonHeader';
import EpgTransactions from '../Player/components/EpgTransactions/EpgTransactions';
import { WhatIncludesContainerPlanSelector } from 'containers/Payment/WhatIncludes/WhatIncludesContainerPlanSelector';
//-----------------------------------------------------------------------------------
import { isNodeMyContent } from '../../utils/Utils';
import { showEpisodeContainer } from '../EpisodeContainer/redux/episodeContainer.actions';
import './style.scss';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';

const CarouselsDisplay = () => {
  const dispatch = useDispatch();
  const { nodesSelected, firstNode, nodes } = useMenuRedirect();
  const [cmsCurrentNode, setCmsCurrentNode] = useState(firstNode);
  const { cmsNodes } = useSelector(state => state.cvCMS);
  const { show: showEpisodContainer } = useSelector(
    state => state.episodeContainer,
  );
  const { isOpen } = useSelector(
    state => state.Player.EpgTransactions.epgTransactions,
  );
  const navData = useSelector(state => state?.cvNavData?.navData);
  const codeMenu = navData?.selected?.code;
  const userHash = useSelector(state => state.user.userhash);
  const { isLoading, layoutType, isInfiniteList } = useGetCmsInfo(
    userHash,
    nodesSelected?.code,
  );
  const headbandIsVisible = useSelector(
    state => state?.headband?.isVisible || '',
  );

  const { showModalCommercial } = useSelector(
    state => state.modalLandingCommercial,
  );
  const { isMobile } = useVerifyIsMobile(769);
  const numberCarousePreload = isMobile ? 3 : 6;

  const controlShowEpisodeContainer = () => {
    // oculta el container cuando el nodo s diferente a miscontenidos
    // pero lo mantiene al retornar de un player
    if (!isNodeMyContent(codeMenu) && showEpisodContainer) {
      dispatch(
        showEpisodeContainer({
          show: false,
        }),
      );
    }
  };

  //ESTE EFECTO OBTIENE EL NODO ACTUAL
  useEffect(
    () => {
      setCmsCurrentNode(nodesSelected?.code);
    },
    [nodes?.length],
  );

  useEffect(() => {
    controlShowEpisodeContainer();
  }, []);

  const carousels = cmsNodes[cmsCurrentNode]?.carousels;
  const { loadedCarousels, sentinelDiv, loading } = useLazyLoadCarousels({
    preloadNumber: numberCarousePreload,
    carousels,
    isLoadingCarousels: isLoading,
    pace: 2,
  });
 
  // espara que no se pierda el marge de abajo cuando se muestra el cintillo
  const getMarginBottonBlueHeadband = () => {
    if (document.getElementById('headband')) {
      let sizeMargi = document.getElementById('headband')?.offsetHeight;
      return sizeMargi || 0;
    }
    return 0;
  };
 
  if (isLoading) return null;

  return (
    <>
      <div
        className={`carousels-display`}
        style={{
          marginBottom: headbandIsVisible
            ? `${getMarginBottonBlueHeadband()}px`
            : '0',
        }}
      >
        {layoutType === 'playandgo' && <AddonHeader />}
        {showModalCommercial && <WhatIncludesContainerPlanSelector /> // si la llave esta apagada y es usr aninimo (pero al logearce ya no es un usu anonimo)
        }
        {showEpisodContainer ? (
          <EpisodeContainer />
        ) : (
          <>
            {(!isInfiniteList || layoutType === 'playandgo') && (
              <Fragment>
                {loadedCarousels.map((module, index) => {
                  return (
                    <ContentsCarouselContainer
                      carouselType={module.component.type}
                      carouselSubType={module?.component?.sub_type}
                      config={module.component}
                      index={index}
                      key={`${module.name}${index}`}
                      name={module.name}
                      node={cmsCurrentNode}
                      title={module?.title || ''}
                    />
                  );
                })}

                {loading && <CarouselLoader />}
                {sentinelDiv()}
              </Fragment>
            )}
            {(layoutType === 'TV' || isInfiniteList) && (
              <div>
                <GridContentsView isLoading={isLoading} />
                <ScrollToTop />
              </div>
            )}
          </>
        )}
        {loadedCarousels.length > 0 && <SubMenu />}
      </div>
      {isOpen && <EpgTransactions isFromNodeMenu />}
      <DeleteConfirmationModal />
      {isNodeMyContent(codeMenu) && (
        <ContainerRecordingBar cmsCurrentNode={cmsCurrentNode} />
      )}
    </>
  );
};

export default CarouselsDisplay;
